// extracted by mini-css-extract-plugin
export default {"settingButton":"settings_settingButton__g3BcJ","settings":"settings_settings__YxPrj"};